export class SelectItem {
    constructor(id: number | string, name: string, icon?: string) {
        this.id = id;
        this.name = name;
        this.icon = icon;
    }

    public id: number | string;
    public name: string;
    public icon?: string;
}



// WEBPACK FOOTER //
// ./src/models/common/SelectItem.ts